var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAstroHiPath(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "eT28IepvEXN1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 800 800",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M794.6061,383.40486c-19.121991-7.68102-32.166475-22.51972-51.286086-30.51979-28.518842-11.93292-48.82174-22.818437-78.505097-28.780117-20.61983-4.14134-93.352304-25.472832-113.5936-31.570792-83.879871-25.26997-185.771915-28.156521-271.375524-8.318611-35.228277,8.16385-66.742002,25.04196-100.672685,34.33476-37.49179,10.26811-119.042367,64.680413-143.348497,97.225123",
    transform: "matrix(1.00489 0.069927 0.069927 1-24.634911-27.245706)",
    fill: "none",
    stroke: "#BFBFBF",
    strokeWidth: 3.6
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAstroHiPath);
export default __webpack_public_path__ + "static/media/astroHiPath.8b30702bf8e045633982ef12cec9748f.svg";
export { ForwardRef as ReactComponent };